import { Pipe, PipeTransform } from '@angular/core';
import { CountriesService } from 'core/services/countries.service';

@Pipe({ name: 'lmsCountryName' })
export class CountryNamePipe implements PipeTransform {
  constructor(public countries: CountriesService) {}

  transform(cca3: string): string {
    return this.countries.getCountryName(cca3);
  }
}
